import {GaugeCircleChartData} from '../influencer';

export class TopicSegmentReport {
  allTopicCharts: GaugeCircleChartData[];
  removeTopics: string[];
  allTopics: any[];
}



// WEBPACK FOOTER //
// ./src/models/measure/topic-segment-report.ts